(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'js-cookie'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('js-cookie'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.jsCookie);
    global.barrierFree = mod.exports;
  }
})(this, function (exports, _jsCookie) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.formatNumAndLetter = formatNumAndLetter;

  var _jsCookie2 = _interopRequireDefault(_jsCookie);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function formatNumAndLetter(originString) {
    // 语言
    var iszhCN = getParameterByName('lang') || _jsCookie2.default.get['language'] || 'zh_CN';
    if (originString) {
      try {
        var temp = '';
        var lang = iszhCN;
        if (lang == 'zh_CN') {
          // 中文
          temp = originString.replace(/([0-9]{2,})/g, '[n1]$1'); // 在连续的数字前面增加标记
        } else {
          // 英文
          temp = originString.replace(/([0-9]{1,})/g, '[n3]$1'); // 在连续的数字前面增加标记
        }
        return temp.replace(/([a-zA-Z]{2,})/g, '[h1]$1'); // 在连续的字母前面增加标记
      } catch (e) {
        console.log(e);
      }
    }
    return originString;
  } //  无障碍中判断

  function getParameterByName(name) {
    /* eslint no-useless-escape: 0 */
    if (name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.href);
      return results == null ? '' : decodeURIComponent(results[1]);
    } else {
      return '';
    }
  }
});